import { Badge } from '@/components/ui/badge';
import { TableCell, TableRow } from '@/components/ui/table';
import type { ComingSoonArche } from '../data/featured-arches';
import { ReplacesList } from './ReplacesList';

interface ComingSoonRowProps {
  arche: ComingSoonArche;
}

/**
 * One not-yet-shipped category, as a table row. Responsive like
 * {@link FeaturedArcheRow}: below md it collapses to Category + Replaces, with
 * the "Coming soon" badge and description folded into the Category cell.
 */
export function ComingSoonRow({ arche }: ComingSoonRowProps) {
  const Icon = arche.icon;

  const badge = (
    <Badge variant="secondary" className="flex-shrink-0">
      Coming soon
    </Badge>
  );

  return (
    <TableRow>
      {/* Category — on mobile also holds the badge + description */}
      <TableCell className="align-top md:align-middle">
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-muted text-muted-foreground">
              <Icon className="h-5 w-5" />
            </span>
            <span className="font-semibold text-foreground/80">{arche.name}</span>
          </div>

          {/* Mobile-only: fold the badge + description into the category cell */}
          <div className="flex flex-col gap-2 md:hidden">
            <p className="line-clamp-2 text-sm text-muted-foreground">{arche.description}</p>
            <div>{badge}</div>
          </div>
        </div>
      </TableCell>

      {/* What it will do — md+ only */}
      <TableCell className="hidden max-w-xs align-middle text-sm text-muted-foreground md:table-cell">
        {arche.description}
      </TableCell>

      {/* Replaces — always visible, emphasized */}
      <TableCell className="bg-primary/[0.04] align-middle">
        <ReplacesList items={arche.compareWith} muted />
      </TableCell>

      {/* Status — md+ only */}
      <TableCell className="hidden align-middle text-right md:table-cell">{badge}</TableCell>
    </TableRow>
  );
}
